import { endDisabledSession } from "./disabledSession";
import Cookies from "js-cookie";

// These failures describe a credential/target account, not the cookie session.
const CREDENTIAL_ENDPOINTS = new Set([
  "userSignin", "repsSignin", "googleSignin", "verifyTwoFactorOtp", "authSwitch",
  "userSignup", "repsSignup", "clinicSignup", "teamSignup", "sendOtp", "resetPassword", "setPassword",
]);

const accountDisabledMiddleware = store => next => action => {
  const failure = action.payload?.data || action.payload;
  if (action.type === "/userData/rejected" && failure?.code === "ACCOUNT_DISABLED") {
    const token = action.meta?.sessionToken;
    const currentCookie = Cookies.get("token");
    const currentToken = store.getState().token?.token;
    // Do not let a delayed rejection mark a switched session failed; the
    // existing route guard clears failed sessions while user data is absent.
    if (currentCookie && currentCookie !== token || currentToken && currentToken !== token) return action;
  }
  const result = next(action);
  if (!action.type?.endsWith("/rejected") || CREDENTIAL_ENDPOINTS.has(action.meta?.arg?.endpointName)) return result;
  if (failure?.code !== "ACCOUNT_DISABLED") return result;
  const authorization = action.meta?.baseQueryMeta?.request?.headers?.get("authorization");
  const requestToken = action.meta?.sessionToken || (/^Bearer\s+(.+)$/i.exec(authorization || "")?.[1]);
  endDisabledSession({ dispatch: store.dispatch, getState: store.getState, token: requestToken,
    type: action.meta?.sessionType, message: failure.message });
  return result;
};

export default accountDisabledMiddleware;
